import React from 'react';
import { usePageLastUpdated } from '../hooks/usePageLastUpdated';
import './PublicationsPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2016-09-18', displayDate: 'September 18, 2016' };

const openBibtex = (file) => {
  window.open(`/papers/bibtex/${file}`, 'Bibtex', 'height=200,width=800');
};

const PublicationCell = ({ title, href, authors, venue, articleHref, bibtexFile }) => (
  <>
    <p>
      <b>
        <a href={href}>{title}</a>
      </b>
    </p>
    <p className="text-small">by {authors}</p>
    <p className="text-small">{venue}</p>
    <p className="text-small">
      {articleHref && (
        <>
          <a href={articleHref} target="_blank" rel="noopener">
            Go to article
          </a>
          {' | '}
        </>
      )}
      <a href="#" onClick={(e) => { e.preventDefault(); openBibtex(bibtexFile); }}>
        Import to BibTex
      </a>
    </p>
  </>
);

const YearRow = ({ year, id }) => (
  <tr>
    <td style={{ width: '30px' }}>
      <span className="text-small text-italic text-gray">
        <a id={id}>{year}</a>
      </span>
    </td>
    <td>
      <span className="text-small">
        <a href="#top">Go to top</a>
      </span>
    </td>
  </tr>
);

const PublicationsPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  const journals = [
    {
      year: '2013',
      id: 'j2013',
      items: [
        {
          title: 'The Impact of Content Delivery Networks on the Internet Ecosystem',
          href: '/papers/jip2013.html',
          authors: 'Manuel Palacin, Miquel Oliver, Jorge Infante, Simon Oechsner, Alex Bikfalvi',
          venue: (
            <>
              published in{' '}
              <a href="http://jip.vmhost.psu.edu/ojs/index.php/jip/index" target="_blank" rel="noopener">
                Journal of Information Policy
              </a>
              , Volume 3, July 2013,{' '}
              <a href="http://jip.vmhost.psu.edu/ojs/" target="_blank" rel="noopener">
                Open Journals Systems
              </a>
            </>
          ),
          articleHref: 'http://jip.vmhost.psu.edu/ojs/index.php/jip/article/view/137',
          bibtexFile: 'jip2013.txt',
        },
      ],
    },
    {
      year: '2011',
      id: 'j2011',
      items: [
        {
          title: 'P2P vs. IP Multicast: Comparing Approaches to IPTV Streaming Based on TV Channel Popularity',
          href: '/papers/comnet2011.html',
          authors: 'Alex Bikfalvi, Jaime García-Reinoso, Iván Vidal, Francisco Valera, Arturo Azcorra',
          venue: (
            <>
              published in{' '}
              <a href="http://www.elsevier.com/locate/comnet" target="_blank" rel="noopener">
                Computer Networks
              </a>
              , Volume 55, Issue 6, Pages 1310-1325, April 2011,{' '}
              <a href="http://www.elsevier.com" target="_blank" rel="noopener">
                Elsevier
              </a>
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1016/j.comnet.2010.12.020',
          bibtexFile: 'comnet2011.txt',
        },
      ],
    },
    {
      year: '2010',
      id: 'j2010',
      items: [
        {
          title: 'Supporting Mobility in an IMS-based P2P IPTV Service: a Proactive Context Transfer Mechanism',
          href: '/papers/comcom2010.html',
          authors: 'Iván Vidal, Jaime García-Reinoso, Antonio de la Oliva, Alex Bikfalvi, Ignacio Soto',
          venue: (
            <>
              published in the{' '}
              <a href="http://www.elsevier.com/locate/comcom" target="_blank" rel="noopener">
                Computer Communications
              </a>
              , Volume 33, Issue 14, Pages 1736-1751, September 2010,{' '}
              <a href="http://www.elsevier.com" target="_blank" rel="noopener">
                Elsevier
              </a>
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1016/j.comcom.2010.05.001',
          bibtexFile: 'comcom2010.txt',
        },
      ],
    },
    {
      year: '2009',
      id: 'j2009',
      items: [
        {
          title: 'Enabling Layered Video Coding for IMS-Based IPTV Home Services',
          href: '/papers/ieeenetwork2009.html',
          authors: 'Iván Vidal, Jaime García-Reinoso, Francisco Valera, Alex Bikfalvi',
          venue: (
            <>
              published in the{' '}
              <a href="http://www.comsoc.org/ni/" target="_blank" rel="noopener">
                IEEE Network
              </a>{' '}
              (special issue on digital home services), Volume 23, Issue 6, Pages 30-35, November-December 2009,{' '}
              <a href="http://www.comsoc.org/" target="_blank" rel="noopener">
                IEEE Communication Society
              </a>
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1109/MNET.2009.5350350',
          bibtexFile: 'ieeenet2009.txt',
        },
        {
          title: 'A Peer-to-Peer IPTV Service Architecture for the IP Multimedia Subsystem',
          href: '/papers/ijcs2009.html',
          authors: 'Alex Bikfalvi, Jaime García-Reinoso, Iván Vidal, Francisco Valera',
          venue: (
            <>
              published in the{' '}
              <a href="http://www3.interscience.wiley.com/journal/117946196/grouphome/home.html" target="_blank" rel="noopener">
                International Journal of Communication Systems
              </a>{' '}
              (special issue on next-generation-networks), Volume 23, Issue 6-7, Pages 780-801, June-July 2010,{' '}
              <a href="http://www.wiley.com/" target="_blank" rel="noopener">
                John Wiley &amp; Sons
              </a>
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1002/dac.1063',
          bibtexFile: 'ijcs2009.txt',
        },
        {
          title: 'H-P2PSIP: Interconnection of P2PSIP Domains for Global Multimedia Services Based on a Hierarchical DHT Overlay Network',
          href: '/papers/comnet2009.html',
          authors: 'Isaías Martinez-Yelmo, Alex Bikfalvi, Carmen Guerrero, Ruben Cuevas Rumín, Andreas Mauthe, Jaime García-Reinoso',
          venue: (
            <>
              published in{' '}
              <a href="http://www.elsevier.com/locate/comnet" target="_blank" rel="noopener">
                Computer Networks
              </a>{' '}
              (special issue on content distribution infrastructures for community networks), Volume 53, Issue 4, Pages 556-568, March 2009,{' '}
              <a href="http://www.elsevier.com/" target="_blank" rel="noopener">
                Elsevier
              </a>
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1016/j.comnet.2008.09.028',
          bibtexFile: 'comnet2009.txt',
        },
      ],
    },
    {
      year: '2008',
      id: 'j2008',
      items: [
        {
          title: 'Enabling Global Multimedia Distributed Services Based on Hierarchical DHT Overlay Networks',
          href: '/papers/ijipt2008.html',
          authors: 'Isaías Martinez-Yelmo, Alex Bikfalvi, Carmen Guerrero, Ruben Cuevas Rumín, Andreas Mauthe',
          venue: (
            <>
              published in{' '}
              <a href="http://www.inderscience.com/browse/index.php?journalID=144" target="_blank" rel="noopener">
                International Journal of Internet Protocol Technology
              </a>{' '}
              (special issue on future multimedia networking), Volume 3, Issue 4, Pages 234-244, 2008,{' '}
              <a href="http://www.inderscience.com/" target="_blank" rel="noopener">
                Inderscience
              </a>
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1504/IJIPT.2008.023772',
          bibtexFile: 'ijipt2008.txt',
        },
        {
          title: 'Geographical Segmentation in Telecommunication Services: Economic and Technological Aspects',
          href: '/papers/telefonica2008.html',
          authors: 'Álvaro Escribano, Arturo Azcorra, Enrique Cañizares, Alex Bikfalvi',
          venue: (
            <>
              published in Regulatory and Economic Policy in Telecommunications, Volume 1, Issue 1, Pages 74-87, September 2008,{' '}
              <a href="http://www.telefonica.es" target="_blank" rel="noopener">
                Telefónica Spain
              </a>
            </>
          ),
          articleHref: 'http://www.telefonica.com/es/about_telefonica/pdf/GEER.pdf',
          bibtexFile: 'telefonica2008.txt',
        },
      ],
    },
  ];

  const conferences = [
    {
      year: '2015',
      id: 'c2015',
      items: [
        {
          title: 'Analyzing the Interconnection Models of Content Providers',
          href: '/papers/tma2015.html',
          authors: 'Manuel Palacin, Alex Bikfalvi, Miquel Oliver',
          venue: (
            <>
              presented at the{' '}
              <a href="http://tma-2015.cba.upc.edu/phd-school" target="_blank" rel="noopener">
                5th PhD School on Traffic Monitoring and Analysis
              </a>
              , April 21 - 22, 2015, Barcelona, Spain
            </>
          ),
          articleHref: null,
          bibtexFile: 'tma2015.txt',
        },
      ],
    },
    {
      year: '2014',
      id: 'c2014',
      items: [
        {
          title: 'Revealing Hidden Interconnections between Access ISPs and Content Providers',
          href: '/papers/eunice2014.html',
          authors: 'Manuel Palacin, Alex Bikfalvi, Miquel Oliver',
          venue: (
            <>
              presented at the{' '}
              <a href="http://conferences.telecom-bretagne.eu/eunice2014/" target="_blank" rel="noopener">
                20th Eunice Open European Summer School and Conference
              </a>
              , September 1 - 5, 2014, Rennes, France
            </>
          ),
          articleHref: null,
          bibtexFile: 'eunice2014.txt',
        },
      ],
    },
    {
      year: '2010',
      id: 'c2010',
      items: [
        {
          title: 'Distributed Management of Application Layer Multicast Trees for IPTV Services',
          href: '/papers/jitel2010.html',
          authors: 'David Diez-Hernandez, Jaime García-Reinoso, Alberto García-Martinez, Alex Bikfalvi, Iván Vidal',
          venue: (
            <>
              presented at the{' '}
              <a href="http://jitel2010.tel.uva.es/" target="_blank" rel="noopener">
                IX Jornadas de Ingeniería Telemática
              </a>
              , September 29 - October 1, 2010, Valladolid, Spain
            </>
          ),
          articleHref: null,
          bibtexFile: 'jitel2010.txt',
        },
      ],
    },
    {
      year: '2009',
      id: 'c2009',
      items: [
        {
          title: 'FLaCoSt: A Novel Peer to Peer Architecture for Video Streaming in a Next Generation Network',
          href: '/papers/ap2ps2009.html',
          authors: 'Jaime García-Reinoso, Alex Bikfalvi, Iván Vidal, Francisco Valera',
          venue: (
            <>
              presented at the{' '}
              <a href="http://www.iaria.org/conferences2009/AP2PS09.html" target="_blank" rel="noopener">
                First International Conference on Advances in P2P Systems
              </a>
              , October 11 - 16, 2009, Sliema, Malta
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1109/AP2PS.2009.37',
          bibtexFile: 'ap2ps2009.txt',
        },
        {
          title: 'Benefits on Using H-P2PSIP in Mobile Environments',
          href: '/papers/jitel2009.html',
          authors: 'Isaías Martinez-Yelmo, Alex Bikfalvi, Carmen Guerrero',
          venue: (
            <>
              presented at the{' '}
              <a href="http://www.jitel09.upct.es/" target="_blank" rel="noopener">
                VIII Jornadas de Ingeniería Telemática
              </a>
              , September 15 - 17, 2009, Cartagena, Spain
            </>
          ),
          articleHref: null,
          bibtexFile: 'jitel2009.txt',
        },
        {
          title: 'Nozzilla: A Peer-to-Peer IPTV Distribution Service for an IMS-based NGN',
          href: '/papers/icns2009.html',
          authors: 'Alex Bikfalvi, Jaime García-Reinoso, Iván Vidal, Francisco Valera',
          venue: (
            <>
              presented at the{' '}
              <a href="http://www.iaria.org/conferences2009/ICNS09.html" target="_blank" rel="noopener">
                Fifth International Conference on Networking and Services
              </a>
              , April 20 - 25, 2009, València, Spain
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1109/ICNS.2009.57',
          bibtexFile: 'icns2009.txt',
        },
      ],
    },
    {
      year: '2008',
      id: 'c2008',
      items: [
        {
          title: 'Enabling Global Multimedia Distributed Services based on Hierarchical DHT Overlay Networks',
          href: '/papers/fmn2008.html',
          authors: 'Isaías Martinez-Yelmo, Alex Bikfalvi, Carmen Guerrero, Ruben Cuevas Rumín, Andreas Mauthe',
          venue: (
            <>
              presented at the{' '}
              <a href="http://fmn2008.dei.uc.pt/" target="_blank" rel="noopener">
                First International Workshop on Future Multimedia Networking
              </a>
              , September 17 - 18, 2008, Cardiff, Wales
            </>
          ),
          articleHref: '/papers/pub/fmn2008.pdf',
          bibtexFile: 'fmn2008.txt',
        },
      ],
    },
    {
      year: '2006',
      id: 'c2006',
      items: [
        {
          title: 'The Management Infrastructure of a Network Measurement System for QoS Parameters',
          href: '/papers/softcom2006.html',
          authors: 'Alex Bikfalvi, Paul Pătraș, Cristian Mihai Vancea, Virgil Dobrotă',
          venue: (
            <>
              presented at the{' '}
              <a href="http://www.fesb.hr/SoftCOM/2006/index.htm" target="_blank" rel="noopener">
                Fourteenth International Conference on Software, Telecommunications and Computer Networks SoftCOM
              </a>
              , September 29 - October 1, 2006, Split-Dubrovnik, Croatia
            </>
          ),
          articleHref: 'http://dx.doi.org/10.1109/SOFTCOM.2006.329752',
          bibtexFile: 'softcom2006.txt',
        },
      ],
    },
  ];

  return (
    <div className="publications-page" id="top">
      <h1>Publications</h1>

      <h2 id="journals">In journals</h2>
      <h3>
        <a href="#j2008">2008</a> | <a href="#j2009">2009</a> | <a href="#j2010">2010</a> |{' '}
        <a href="#j2011">2011</a> | <a href="#j2013">2013</a>
      </h3>
      <table className="publication padding-4px">
        <tbody>
          {journals.map((group) => (
            <React.Fragment key={group.id}>
              <YearRow year={group.year} id={group.id} />
              {group.items.map((item, i) => (
                <tr key={`${group.id}-${i}`}>
                  <td></td>
                  <td>
                    <PublicationCell {...item} />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <h2 id="conferences">In conferences and workshops</h2>
      <h3>
        <a href="#c2006">2006</a> | <a href="#c2008">2008</a> | <a href="#c2009">2009</a> |{' '}
        <a href="#c2010">2010</a> | <a href="#c2014">2014</a> | <a href="#c2015">2015</a>
      </h3>
      <table className="publication padding-4px">
        <tbody>
          {conferences.map((group) => (
            <React.Fragment key={group.id}>
              <YearRow year={group.year} id={group.id} />
              {group.items.map((item, i) => (
                <tr key={`${group.id}-${i}`}>
                  <td></td>
                  <td>
                    <PublicationCell {...item} />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PublicationsPage;
